import { useLocation } from 'react-router-dom'

import { useEffect } from 'modules/core/hooks/useEffect'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import PromotionContent from 'modules/marketplace_modules/components/PromotionContent'

const ModulesPromotionsPage = () => {
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)

  useEffect(() => {
    track(trackingEvents.marketplaceModules.visitModulesPromotionPage, {
      upsell_origin: queryParams.get('upsell_origin'),
      promotion: 'black_friday',
    })
  }, [])

  return (
    <ResponsivePage.Body>
      <PromotionContent />
    </ResponsivePage.Body>
  )
}

export default ModulesPromotionsPage
